import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid m-0 border-round surface-100 fadein"
}
const _hoisted_2 = {
  key: 0,
  class: "col m-0"
}
const _hoisted_3 = { class: "grid m-0 p-0" }
const _hoisted_4 = { class: "col m-0 p-0 pb-1" }
const _hoisted_5 = { class: "col-1 m-0 p-1 pr-8" }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "col m-0 p-1" }
const _hoisted_8 = ["textContent"]
const _hoisted_9 = {
  key: 1,
  class: "col p-7 text-center text-gray-500 text-sm"
}

import { computed, ref, toRefs, watch } from 'vue';
import Chart from 'primevue/chart';

interface Props {
  disciplines: string[];
  color: string;
  showMore: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewReportTrackMore',
  props: {
    disciplines: { default: () => [] },
    color: { default: 'blue' },
    showMore: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const { disciplines, color, showMore } = toRefs(props);

const colors = [
  {
    style: 'blue',
    hex: ['#75C6E4', '#75C6E4', '#75C6E4', '#75C6E4', '#AAD9EA', '#40B3DD'],
  },
  {
    style: 'purple',
    hex: ['#A19DDC', '#A19DDC', '#A19DDC', '#A19DDC', '#C3C2E6', '#7E78D2'],
  },
  {
    style: 'pink',
    hex: ['#DDB5D0', '#DDB5D0', '#DDB5D0', '#DDB5D0', '#E5D0DF', '#D49BC1'],
  },
  {
    style: 'orange',
    hex: ['#EEBE79', '#EEBE79', '#EEBE79', '#EEBE79', '#EFD5AD', '#EDA745'],
  },
];

const chart = ref({
  datasets: [
    {
      data: [],
      backgroundColor: [],
    },
  ],
});

watch(
  () => [showMore.value, disciplines.value],
  () => defineChartData(),
);

const hasDisciplines = computed(() => Object.keys(disciplines.value).length);

const defineChartData = () => {
  const chartObject = {
    data: disciplines.value.map(({ discipline }) => discipline.total),
    backgroundColor: colors.find((item) => color.value === item.style).hex,
  };

  chart.value.datasets[0] = chartObject;
};

const disciplineTotalStyle = () => `text-color-${color.value} text-lg font-semibold`;

return (_ctx: any,_cache: any) => {
  return (_unref(showMore))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (hasDisciplines.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_unref(Chart), {
                    type: "doughnut",
                    data: chart.value
                  }, null, 8, ["data"])
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(disciplines), ({ discipline }, key) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: key,
                  class: "grid pt-1 pl-1"
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", {
                      class: _normalizeClass(disciplineTotalStyle(key)),
                      textContent: _toDisplayString(new Intl.NumberFormat().format(discipline.total))
                    }, null, 10, _hoisted_6)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", {
                      class: _normalizeClass(`inline-block text-color-${_unref(color)} text-sm`),
                      style: {"margin-top":"2px"},
                      textContent: _toDisplayString(discipline.name)
                    }, null, 10, _hoisted_8)
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, "No data for Disciplines"))
      ]))
    : _createCommentVNode("", true)
}
}

})